export enum Transporter {
  LaPosteColissimo = "LA_POSTE_COLISSIMO",
  TNT = "TNT",
  Other = "OTHER"
}
